import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import lodashCompact from 'lodash/fp/compact';

import {
  createInitialValues,
} from 'client/helpers/formikHelpers';

import branch from 'client/core/branch';

import SrFormikField, {
  SR_FIELD_THEME_ADMIN_HORIZONTAL_SMALL,
} from 'client/components/SrFormikField';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import ButtonDeprecated, {
  BUTTON_THEME_YELLOW,
} from 'client/components/ButtonDeprecated';
import loadBreedRestrictionDefinitionsAction from 'client/actions/Partner/loadBreedRestrictionDefinitions';

function getFormFields({ breedRestrictionDefinitions }) {
  return breedRestrictionDefinitions.reduce((memo, def) => ([
    ...memo,
    {
      id: def.name,
      title: def.name,
      type: 'checkbox',
    },
  ]), []);
}

function breedNamesToInitialFormValues({ breedRestrictionDefinitions, breedNames }) {
  return breedRestrictionDefinitions.reduce((memo, def) => ({
    ...memo,
    [def.name]: breedNames.includes(def.name),
  }), {});
}

@branch({
  breedRestrictionDefinitions: ['breedRestrictions', 'definitions'],
})
class SrEditBreedRestrictionsModal extends Component {
  static propTypes = {
    initialBreedNamesEnabled: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    breedRestrictionDefinitions: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { breedRestrictionDefinitions, dispatch } = this.props;
    if (!breedRestrictionDefinitions) {
      dispatch(loadBreedRestrictionDefinitionsAction);
    }
  }

  _onSubmit = (values) => {
    const { onSubmit } = this.props;

    const breedRestrictionNames = Object.keys(values).reduce((memo, breedName) => lodashCompact([
      ...memo,
      values[breedName] && breedName,
    ]), []);

    onSubmit(breedRestrictionNames);
  }

  render() {
    const {
      onClose,
      initialBreedNamesEnabled,
      breedRestrictionDefinitions,
    } = this.props;

    if (!breedRestrictionDefinitions) {
      return null;
    }

    const formFields = getFormFields({
      breedRestrictionDefinitions,
    });

    return (
      <SrDarkModal onClose={onClose}>
        <SrModalContent onCloseIconClick={onClose}>
          <SrBox paddingBottom='20px'>
            <SrText weight='bold' size='2xl'>
              Restricted Breeds
            </SrText>
          </SrBox>
          <Formik
            initialValues={createInitialValues({
              formFields: formFields,
              defaultValues: breedNamesToInitialFormValues({
                breedRestrictionDefinitions,
                breedNames: initialBreedNamesEnabled,
              }),
            })}
            onSubmit={this._onSubmit}
            render={(formikBag) => (
              <Form>
                {formFields.map((formField) => (
                  <SrFormikField
                    key={formField.id}
                    formField={formField}
                    formikBag={formikBag}
                    className={SR_FIELD_THEME_ADMIN_HORIZONTAL_SMALL}
                  />
                ))}
                <SrBox position='fixed' bottom='80px' width='290px'>
                  <SrBox padding='0 20px'>
                    <ButtonDeprecated
                      type='submit'
                      theme={BUTTON_THEME_YELLOW}
                      disabled={!formikBag.isValid}
                      onClick={formikBag.handleSubmit}
                    >
                      Save
                    </ButtonDeprecated>
                  </SrBox>
                </SrBox>
              </Form>
            )}
          />
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrEditBreedRestrictionsModal.displayName = 'SrEditBreedRestrictionsModal';

export default SrEditBreedRestrictionsModal;
